<template lang="pug">
  e-button-upload-file(
    v-if="!$hasProVersion"
    ref="uploader"
    :validation-rules="rules"
    :accept="acceptedFileExtensions"
    :button-class="buttonClass"
    multiple
    :loading="loading"
    @onload="upload"
    data-test="document-upload-button"
  )
    e-svg-icon(v-if="xsDevice") plus
    span(v-else) {{ $t('Download') }}
  v-btn(
    v-else
    class="main-button"
    :class="{ 'mobile-fixed-button': xsDevice, 'w-100': fullWidth }"
    @click="goToCreatePage"
    data-test="document-create-button"
  )
    e-svg-icon(v-if="xsDevice") plus
    span(v-else) {{ $t('Download') }}
</template>

<script>
import Base64js from 'base64-js'
import converters from '~/mixins/methods/converters'
import EButtonUploadFile from '~/components/elements/buttons/e-button-upload-file'
import responsive from '~/mixins/pages/responsive'
import upload from '~/modules/documents/mixins/upload'

export default {
  name: 'EButtonDocumentUpload',
  components: {
    EButtonUploadFile
  },
  mixins: [upload, converters, responsive],
  props: {
    fullWidth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    buttonClass() {
      let classes = ''
      if (this.xsDevice) {
        classes += 'mobile-fixed-button'
      }
      if (this.fullWidth) {
        classes += 'w-100'
      }
      return classes
    }
  },
  methods: {
    async upload(files) {
      const { valid, errors } = await this.$refs.uploader.validate(files)
      if (!valid) {
        const errMessage = this._.get(errors, '[0]')
        this.$notification.error(errMessage)
        return
      }
      try {
        this.loading = true
        for (const file of files) {
          const arrayBuffer = await this.blobToArrayBuffer(file)
          const uint8View = new Uint8Array(arrayBuffer)
          const base64Str = Base64js.fromByteArray(uint8View)
          try {
            const payload = {
              file: base64Str,
              filename: file?.name,
              title: file?.name.split('.').slice(0, -1).join('.')
            }
            const document = await this.$store.dispatch('documents/create', {
              payload,
              save: this.$route.name === 'documents'
            })

            if (files && files.length === 1) {
              await this.$router.push({ path: `/documents/${document?.id}` })
              window.dataLayer &&
                window.dataLayer.push({
                  event: 'document_downloaded',
                  email: this._.get(this.$User, 'email')
                })
              return
            }

            this.$notification.success(
              this.$t('{document} has been successfully uploaded', { document: file.name })
            )
          } catch (e) {
            const message = this._.get(e, 'response.data.message')
            this.$notification.error(
              this.$t('Error occurred with {document} - {error}', {
                document: file.name,
                error: message
              })
            )
          }
        }
        await this.$store.dispatch('documents/getAll')
        window.dataLayer &&
          window.dataLayer.push({
            event: 'document_downloaded',
            email: this._.get(this.$User, 'email')
          })
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.loading = false
      }
    },
    goToCreatePage() {
      this.$router.push({ name: 'documents-create' })
    }
  }
}
</script>

<style scoped lang="scss"></style>
